import React, { useContext, useState } from "react";
import { AppContext } from "./context/context";

import Reviews from "./Reviews";
import MyModal from "./ReviewsModal";

import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function BooksPage() {
  const { setCurrentBook } = useContext(AppContext);
  const navigate = useNavigate();

  const localBook = JSON.parse(localStorage.getItem("currentBook"));
  const currentBook = localBook?.thisbook || {};

  const [mainImage, setMainImage] = useState(currentBook.photo);
  const [dropdownActive, setDropdownActive] = useState(false);

  const handleSetBook = (book) => {
    localStorage.setItem("currentBook", JSON.stringify({ thisbook: book }));
    setCurrentBook(book);
    navigate(book.bookPage);
  };

  return (
    <div className="antialiased booksCarousel">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <div className="flex flex-col md:flex-row -mx-4">
          <div className="md:flex-1 px-4">
            <div>
              <div className="h-1/2 md:h-fit rounded-lg bg-none mb-4">
                <Link
                  to={"/books"}
                  className="px-6 py-2 box-content font-semibold rounded-xl mb-2 bg-red-600 hover:bg-red-700 text-white text-center inline-flex items-center font-maragsa tracking-wide uppercase"
                >
                  Back to books
                </Link>
                <img
                  className="h-full max-h-80 mx-auto md:rounded-none rounded-t-lg mb-2"
                  src={mainImage}
                  alt={currentBook.title}
                />
              </div>
            </div>
          </div>

          <div className="md:flex-1 px-4">
            <p className="mb-2 leading-tight tracking-tight text-white text-2xl md:text-5xl">
              {currentBook.title}
            </p>
            <p className="text-gray-500 text-sm">
              By{" "}
              <a href="/author" className="text-yellow-600 hover:underline">
                Herbert Deleon
              </a>
            </p>

            <p className="text-white">{currentBook.description}</p>

            <div className="inline-flex py-4 space-x-4 items-stretch">
              <div className="inline-block">
                <button
                  onClick={() => setDropdownActive(!dropdownActive)}
                  className="px-6 py-2 box-content border border-yellow-800 font-semibold rounded-xl bg-yellow-600 hover:bg-yellow-800 hover:shadow-md text-white text-center inline-flex items-center font-maragsa tracking-wide uppercase"
                  type="button"
                >
                  Buy Now
                  <svg
                    className="w-4 h-4 ml-2"
                    aria-hidden="true"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </button>

                {dropdownActive && (
                  <div className="z-10 divide-y divide-gray-100 border rounded-xl shadow bg-yellow-800 border-yellow-700">
                    <ul className="py-2 text-sm text-gray-200">
                      {["ebook", "paperback", "hardcover", "audiobook"].map((type) =>
                        currentBook.buyLinks?.[type] ? (
                          <li key={type} className="group relative">
                            <button className="w-full text-left px-4 py-2 hover:bg-gray-600 dark:hover:text-white font-semibold capitalize">
                              {type}
                            </button>
                            <ul className="absolute left-full top-0 mt-0 ml-0 w-48 border rounded-xl shadow-lg z-20 group-hover:block hidden bg-gray-800">
                              {Object.entries(
                                currentBook.buyLinks[type]
                              ).map(([store, url]) => (
                                <li key={store}>
                                  <a
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="block px-4 py-2 hover:bg-gray-100 hover:bg-gray-600 text-yellow-600 capitalize"
                                  >
                                    {store.replace(/([A-Z])/g, " $1")}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ) : null
                      )}
                    </ul>
                  </div>
                )}
              </div>

              <MyModal />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-white">
        <p className="text-bold text-center text-2xl md:text-5xl pt-4">
          Reviews
        </p>
        <Reviews />
      </div>
    </div>
  );
}
